export enum CustomerContractType {
    Public = 'PUBLIC',
    Private = 'PRIVATE',
}